"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateGuid = void 0;
function generateGuid() {
    var S4 = function () {
        // tslint:disable-next-line:no-bitwise
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    };
    return "" + S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4();
}
exports.generateGuid = generateGuid;
//# sourceMappingURL=generate-guid.js.map